import React, { Fragment, useEffect, useState } from "react";
import {Container} from "react-bootstrap"
import axios from 'axios';
import Nav from "../nav/Nav";
import MyBook from "../page/Flipbook";
import MyBookCel from "../page/FlipbookCel";
import { STORAGE_PRODUCTS_CART } from "../../utils/constants";
import swal from 'sweetalert';
import { siteURL, woocomPart, consumerKey, consumerSecret } from "../../utils/constants";




export default function FlipCliente(){

    const [productsCart, setProductsCart] = useState([]);
    useEffect(() => {
     getProductsCart();
   }, [])
   const getProductsCart = () =>{
     const idsProducts = localStorage.getItem(STORAGE_PRODUCTS_CART);
   
     if(idsProducts){
       const idsProductsSplit = idsProducts.split(',');
       setProductsCart(idsProductsSplit)
     }else{
       setProductsCart([]);
     }
   }
   
   
   const addProductCart = async (idU) => {
    

    let link = `${siteURL}${woocomPart}products/${idU}?consumer_key=${consumerKey}&consumer_secret=${consumerSecret}`;
    let config = {
        method: 'get',
        url: link,
        headers: { }
      };
      axios(config).then(function (response) {
         return response.data
        }).then((item)=>{
          let stock = item.stock_quantity
          if(stock>0){
            const idsProducts = productsCart;
            idsProducts.push(idU);
            setProductsCart(idsProducts);
            localStorage.setItem(STORAGE_PRODUCTS_CART, productsCart);
           
            swal({
             title: "Listo",
             text: "Producto añadido al carrito",
             icon:"success",
             button:"Aceptar",
             timer:"2200"
         });
          }else{
            swal({
              title: "Lo Siento",
              text: "Tenemos producto agotado",
              icon:"error",
              button:"Aceptar",
              timer:"2200"
          });
          }
        })
        .catch(function (error) {
        console.log(error);
        return null;
    });

   

   };

   
    
   
      return (
      
    <Fragment>
      <Nav  productsCart={productsCart} getProductsCart={getProductsCart}/>
     <Container>
     <div className="flipbookComputadora">
          <MyBook addProductCart={addProductCart}/>
      </div>
      <div className="flipbookCelular">
          <MyBookCel addProductCart={addProductCart}/>
      </div>

          
      </Container>


    </Fragment>
  );

  
}

